import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Breadcrumb = ({ items }) => {
  const navigate = useNavigate();

  return (
    <Container>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <Separator>/</Separator>}
          {item.path ? (
            <Link onClick={() => navigate(item.path)}>
              {item.icon && <Icon>{item.icon}</Icon>}
              {item.label}
            </Link>
          ) : (
            <Current>
              {item.icon && <Icon>{item.icon}</Icon>}
              {item.label}
            </Current>
          )}
        </React.Fragment>
      ))}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  font-size: 14px;
`;

const Link = styled.button`
  background: none;
  border: none;
  color: #667eea;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;
  
  &:hover {
    background: #f0f2ff;
    color: #5568d3;
  }
`;

const Current = styled.span`
  color: #2c3e50;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
`;

const Separator = styled.span`
  color: #bbb;
`;

const Icon = styled.span`
  font-size: 16px;
`;

export default Breadcrumb;
